import React from 'react'
import { requestSelection } from 'services/CurrentAwarenessService'
import connect from 'components/shared/connect'
import { mapResponse } from 'libraries/front-end-core/helpers/dataflow'
import { map } from 'rxjs/operators'
import AccordionWrapperContainer from 'redux/containers/components/accordion/AccordionWrapperContainer'

const Wrapper = ({ group }) => {
  const cxNames = {
    accordionContainer: 'layout-width-container mb6',
    groupHeader: {
      depthStyle: () => {
        return 'bg-white black b--dark-cerulean'
      },
      iconDepthStyle: depth => {
        switch (depth) {
          case 2:
            return 'white'
          default:
            return 'black o-80'
        }
      }
    },
    contentHeader: {
      borderColor: 'b--dark-cerulean',
      headerBackground: 'bg-ghost-grey'
    },
    content: {
      divider: 'bt--dark-cerulean'
    },
    borderColor: 'b--dark-cerulean'
  }

  return (
    <div className='layout-width-constraint'>
      <AccordionWrapperContainer
        {...{ cxNames, group }}
        title={null}
        eventCategory='CA'
        showAllS1
        SectionHeaderOverride={() => null}
        styleTitle={false}
        contained
      />
    </div>
  )
}

export default connect(
  ({ flavour, selectedIds, aol }) => requestSelection(flavour, selectedIds, aol).pipe(map(mapResponse(group => ({ group }))))
)(Wrapper)
